<template>
  <b-container>
    <v-popover :open="popover" offset="16" placement="left">
      <!-- This will be the popover target (for the events and position) -->
      <div class="d-flex align-items-center">
        <div class="avatar p-1">
          <b-avatar class="mr-2 cursor-point" size="2em" square v-bind:src="organization.logoUrl
          ? organization.logoUrl +
          '/' +
          getAuthentication()
          : ''" @mouseleave="triggerUnClickPopover" @mouseover="triggerClickPopover"></b-avatar>
        </div>
        <div class="media-support-info">
          <h6>{{ organization.name }}</h6>
          <p v-if="organization.phone" class="mb-0 font-size-12">{{ organization.phone }}</p>
          <p v-else class="mb-0 font-size-12">{{ organization.email }}</p>
        </div>
      </div>
      <!-- This will be the content of the popover -->
      <template slot="popover">
        <div class="user-details-block">
          <div class="user-profile text-center">
            <b-avatar class="img-fluid rounded avatar-100" size="6rem" v-bind:src="organization.logoUrl
            ? organization.logoUrl +
            '/' +
            getAuthentication()
            : ''"></b-avatar>
          </div>
          <div class="text-center mt-3">
            <h4>
              <b>{{ organization.name }}</b>
            </h4>
            <p>{{ organization.country }}</p>
            <p>{{ organization.email }}</p>
            <hr />
            <ul class="
                doctoe-sedual
                d-flex
                align-items-center
                justify-content-between
                p-0
              ">
              <li class="text-center">
                <p class="counter">{{ organization.phone }}</p>
              </li>
            </ul>
          </div>
        </div>
      </template>
    </v-popover>
  </b-container>
</template>
<script>
import IqCard from "../../components/xray/cards/iq-card";
import { xray } from "../../config/pluginInit";

export default {
  name: "OrganizationInfo",
  components: { IqCard },
  props: {
    organization: {
      default: {},
    },
  },
  mounted() {
    xray.index();
  },
  computed: {},
  methods: {
    getAuthentication() {
      return localStorage.getItem('authorization');
    },
    triggerUnClickPopover() {
      this.popover = false;
    },
    triggerClickPopover() {
      this.popover = true;
    },
  },
  data() {
    return {
      popover: false,
    };
  },
};
</script>
